import styled from "styled-components";

export const RadioButtonStyled = styled.input``;
